// Mirayama: Hotjar events, so recordings can be found by what the visitor did.
// Hotjar loads only after consent (snippets/mm-hotjar.liquid); until then window.hj does not
// exist and nothing here is sent. Listens on the document, touches none of Dawn's scripts.
//   add_to_cart            a product form (action /cart/add) is submitted
//   checkout_click         the Checkout button in the cart drawer or on the cart page
//   enquiry_submitted      the enquiry form (sections/mm-enquiry-form.liquid)
//   notify_me_submitted    the sold-out "Notify me" form (snippets/buy-buttons.liquid)
//   ask_about_fit_click    a link to the enquiry form with the reason "Size & fit"
//   colour_finder_used     the first touch of the colour finder strip
//   journal_article_read   a journal article scrolled past 60% of its body
(function () {
  var sent = {};
  function send(name, once) {
    if (once && sent[name]) return;
    sent[name] = true;
    if (window.hj) window.hj('event', name);
  }

  document.addEventListener(
    'submit',
    function (e) {
      var form = e.target;
      if (!form || form.tagName !== 'FORM') return;
      var action = form.getAttribute('action') || '';
      if (action.indexOf('/cart/add') !== -1) send('add_to_cart');
      if (form.classList.contains('mm-enquiry__form')) send('enquiry_submitted');
      if (form.classList.contains('mm-notify__form')) send('notify_me_submitted');
    },
    true
  );

  document.addEventListener(
    'click',
    function (e) {
      if (!e.target || !e.target.closest) return;
      if (e.target.closest('[name="checkout"]')) send('checkout_click');
      var link = e.target.closest('a[href*="/pages/inquiries"]');
      if (link && /reason=Size/.test(link.getAttribute('href') || '')) send('ask_about_fit_click');
    },
    true
  );

  document.addEventListener(
    'pointerdown',
    function (e) {
      if (e.target && e.target.closest && e.target.closest('.mm-cf__field')) send('colour_finder_used', true);
    },
    true
  );

  function watchArticle() {
    var body = document.querySelector('.mm-article__body');
    if (!body || !('IntersectionObserver' in window)) return;
    // A one-pixel sentinel six tenths of the way down the body.
    if (getComputedStyle(body).position === 'static') body.style.position = 'relative';
    var mark = document.createElement('span');
    mark.setAttribute('aria-hidden', 'true');
    mark.style.cssText = 'position:absolute;top:60%;left:0;width:1px;height:1px;pointer-events:none';
    body.appendChild(mark);
    var observer = new IntersectionObserver(function (entries) {
      if (!entries.some(function (entry) { return entry.isIntersecting; })) return;
      send('journal_article_read', true);
      observer.disconnect();
    });
    observer.observe(mark);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watchArticle);
  } else {
    watchArticle();
  }
})();
